// Must always come first
import './bootstrap';

// Must always come second
import './error-logger';

import './configure-promise-queue';
import './doc-init';
import './error-test';
import './globals';
import './init-analytics';
import './intl-polyfill';
import './live-updater';
import './load-gapi';
import './pinocchio';
import './safari-tab-index';
import './subscriber';
import './token-watcher';
import './trellis-client';
import './update-announcements';
import './vendor-patches';
import './window-resize-watcher';

// Must always come last
import './cleanup';



// WEBPACK FOOTER //
// ./app/scripts/entry/app.js